/* ==========================================================================
   NURSEQUIZPREP — EXAM CATALOGUE
   Every track a student can practise, grouped to match the site's service
   sections: Nursing Exams, Proctored Exams, Pre-Med & Science, Practice
   Quizzes, and Certifications.

   Section weights follow each exam's published blueprint where one exists,
   so a filtered or full-length paper mirrors the real test.
   ========================================================================== */

window.XP_CATALOG = [

  /* =====================================================================
     NURSING EXAMS — licensure and admission
     ===================================================================== */
  {
    id: 'nclex-rn', name: 'NCLEX-RN', icon: '⚕️', group: 'nursing', science: true,
    aliases: ['nclex'],
    blurb: 'Registered nurse licensure. Client Needs categories with clinical-judgement item stems.',
    minutes: 300, fullLen: 145, pass: 75,
    sections: [
      { id: 'safe-care', name: 'Management of Care & Safety', weight: 30 },
      { id: 'health-promo', name: 'Health Promotion & Maintenance', weight: 9 },
      { id: 'psychosocial', name: 'Psychosocial Integrity', weight: 9 },
      { id: 'physiological', name: 'Physiological Integrity', weight: 52 }
    ]
  },
  {
    id: 'nclex-pn', name: 'NCLEX-PN', icon: '⚕️', group: 'nursing', science: true,
    blurb: 'Practical/vocational nurse licensure. Coordinated Care emphasis and LPN scope of practice.',
    minutes: 300, fullLen: 145, pass: 75,
    sections: [
      { id: 'coordinated-care', name: 'Coordinated Care', weight: 20 },
      { id: 'safety-infection', name: 'Safety & Infection Control', weight: 12 },
      { id: 'health-promo', name: 'Health Promotion & Maintenance', weight: 9 },
      { id: 'psychosocial', name: 'Psychosocial Integrity', weight: 11 },
      { id: 'physiological', name: 'Physiological Integrity', weight: 48 }
    ]
  },
  {
    id: 'nclex-ngn', name: 'NCLEX Next Gen (NGN)', icon: '🧠', group: 'nursing', science: true,
    blurb: 'Next Generation NCLEX clinical judgement model — case studies, bow-tie and trend items.',
    minutes: 300, fullLen: 140, pass: 75,
    sections: [
      { id: 'recognize', name: 'Recognise & Analyse Cues', weight: 25 },
      { id: 'hypotheses', name: 'Prioritise Hypotheses', weight: 20 },
      { id: 'solutions', name: 'Generate Solutions', weight: 20 },
      { id: 'actions', name: 'Take Action', weight: 20 },
      { id: 'evaluate', name: 'Evaluate Outcomes', weight: 15 }
    ]
  },
  {
    id: 'ati-teas', name: 'ATI TEAS 7', icon: '📘', group: 'nursing', science: true,
    blurb: 'Nursing school entrance exam. 170 questions across four sections in 209 minutes.',
    minutes: 209, fullLen: 170, pass: 60,
    sections: [
      { id: 'reading', name: 'Reading', weight: 31 },
      { id: 'math', name: 'Mathematics', weight: 22 },
      { id: 'science', name: 'Science', weight: 31 },
      { id: 'english', name: 'English & Language Usage', weight: 16 }
    ]
  },
  {
    id: 'hesi', name: 'HESI A2', icon: '📗', group: 'nursing', science: true,
    blurb: 'Health Education Systems admission assessment. Schools select which sections you sit.',
    minutes: 240, fullLen: 160, pass: 75,
    sections: [
      { id: 'reading', name: 'Reading Comprehension', weight: 18 },
      { id: 'math', name: 'Mathematics', weight: 18 },
      { id: 'vocab', name: 'Vocabulary & General Knowledge', weight: 16 },
      { id: 'grammar', name: 'Grammar', weight: 12 },
      { id: 'anatomy', name: 'Anatomy & Physiology', weight: 16 },
      { id: 'biology', name: 'Biology', weight: 10 },
      { id: 'chemistry', name: 'Chemistry', weight: 10 }
    ]
  },
  {
    id: 'kaplan-nursing', name: 'Kaplan Nursing (KNAT)', icon: '📕', group: 'nursing', science: true,
    aliases: ['knat'],
    blurb: 'Kaplan Nursing School Admission Test — reading, maths, writing and science.',
    minutes: 165, fullLen: 91, pass: 65,
    sections: [
      { id: 'reading', name: 'Reading', weight: 24 },
      { id: 'math', name: 'Mathematics', weight: 30 },
      { id: 'writing', name: 'Writing', weight: 20 },
      { id: 'science', name: 'Science', weight: 26 }
    ]
  },
  {
    id: 'nln-pax', name: 'NLN PAX / NEX', icon: '📙', group: 'nursing', science: true,
    aliases: ['nln-nex'],
    blurb: 'National League for Nursing Pre-Admission Examination — verbal, maths and science.',
    minutes: 165, fullLen: 214, pass: 60,
    sections: [
      { id: 'verbal', name: 'Verbal Ability', weight: 30 },
      { id: 'math', name: 'Mathematics', weight: 30 },
      { id: 'science', name: 'Science', weight: 40 }
    ]
  },
  {
    id: 'vati', name: 'ATI VATI / Capstone Predictor', icon: '🎯', group: 'nursing', science: true,
    aliases: ['ati-capstone'],
    blurb: 'Virtual ATI and Capstone Content Review — predictor of NCLEX readiness.',
    minutes: 180, fullLen: 150, pass: 70,
    sections: [
      { id: 'medsurg', name: 'Adult Medical-Surgical', weight: 30 },
      { id: 'pharm', name: 'Pharmacology', weight: 20 },
      { id: 'maternal', name: 'Maternal-Newborn & Paediatrics', weight: 20 },
      { id: 'mental', name: 'Mental Health', weight: 15 },
      { id: 'leadership', name: 'Leadership & Community', weight: 15 }
    ]
  },

  /* =====================================================================
     ATI PROCTORED EXAMS — specialty
     ===================================================================== */
  {
    id: 'ati-pharmacology', name: 'ATI Pharmacology Proctored', icon: '💊', group: 'proctored', science: true,
    blurb: 'Drug classes, adverse effects, nursing implications and safe administration.',
    minutes: 90, fullLen: 70, pass: 70,
    sections: [
      { id: 'cardio', name: 'Cardiovascular Agents', weight: 22 },
      { id: 'neuro', name: 'Neurological & Psychiatric Agents', weight: 20 },
      { id: 'anti', name: 'Anti-infectives', weight: 18 },
      { id: 'endocrine', name: 'Endocrine Agents', weight: 20 },
      { id: 'pain', name: 'Pain & Inflammation', weight: 20 }
    ]
  },
  {
    id: 'ati-med-surg-rn', name: 'ATI Med-Surg — RN', icon: '🛏️', group: 'proctored', science: true,
    aliases: ['ati-med-surg'],
    blurb: 'Adult medical-surgical nursing for RN programmes. Full assessment and evaluation scope.',
    minutes: 90, fullLen: 70, pass: 70,
    sections: [
      { id: 'cardio', name: 'Cardiovascular', weight: 22 },
      { id: 'resp', name: 'Respiratory', weight: 18 },
      { id: 'gi', name: 'Gastrointestinal', weight: 15 },
      { id: 'renal', name: 'Renal & Endocrine', weight: 20 },
      { id: 'neuro', name: 'Neurological & Musculoskeletal', weight: 25 }
    ]
  },
  {
    id: 'ati-med-surg-pn', name: 'ATI Med-Surg — PN', icon: '🛏️', group: 'proctored', science: true,
    blurb: 'Adult medical-surgical for PN/LVN programmes. Data collection and scope limits.',
    minutes: 90, fullLen: 70, pass: 70,
    sections: [
      { id: 'cardio', name: 'Cardiovascular', weight: 22 },
      { id: 'resp', name: 'Respiratory', weight: 18 },
      { id: 'gi', name: 'Gastrointestinal', weight: 15 },
      { id: 'renal', name: 'Renal & Endocrine', weight: 20 },
      { id: 'scope', name: 'Scope of Practice & Data Collection', weight: 25 }
    ]
  },
  {
    id: 'ati-fundamentals', name: 'ATI Nursing Fundamentals', icon: '🧰', group: 'proctored', science: true,
    blurb: 'Nursing process, safety, infection control, basic skills and documentation.',
    minutes: 90, fullLen: 60, pass: 70,
    sections: [
      { id: 'process', name: 'Nursing Process & Assessment', weight: 25 },
      { id: 'safety', name: 'Safety & Infection Control', weight: 25 },
      { id: 'skills', name: 'Basic Skills & Comfort', weight: 25 },
      { id: 'legal', name: 'Legal, Ethical & Documentation', weight: 25 }
    ]
  },
  {
    id: 'ati-maternal', name: 'ATI Maternal-Newborn', icon: '👶', group: 'proctored', science: true,
    blurb: 'Antepartum, intrapartum, postpartum and newborn care.',
    minutes: 90, fullLen: 60, pass: 70,
    sections: [
      { id: 'ante', name: 'Antepartum', weight: 28 },
      { id: 'intra', name: 'Intrapartum', weight: 24 },
      { id: 'post', name: 'Postpartum', weight: 24 },
      { id: 'newborn', name: 'Newborn Care', weight: 24 }
    ]
  },
  {
    id: 'ati-pediatric', name: 'ATI Pediatric Nursing', icon: '🧸', group: 'proctored', science: true,
    blurb: 'Growth and development, paediatric conditions and family-centred care.',
    minutes: 90, fullLen: 60, pass: 70,
    sections: [
      { id: 'growth', name: 'Growth & Development', weight: 25 },
      { id: 'resp', name: 'Respiratory & Cardiac', weight: 25 },
      { id: 'chronic', name: 'Chronic & Acute Conditions', weight: 25 },
      { id: 'safety', name: 'Safety & Family Care', weight: 25 }
    ]
  },
  {
    id: 'ati-mental-health', name: 'ATI Mental Health', icon: '🧠', group: 'proctored', science: true,
    blurb: 'Therapeutic communication, psychiatric disorders, crisis and psychopharmacology.',
    minutes: 90, fullLen: 60, pass: 70,
    sections: [
      { id: 'therapeutic', name: 'Therapeutic Communication', weight: 25 },
      { id: 'disorders', name: 'Psychiatric Disorders', weight: 30 },
      { id: 'crisis', name: 'Crisis & Safety', weight: 22 },
      { id: 'psychopharm', name: 'Psychopharmacology', weight: 23 }
    ]
  },
  {
    id: 'ati-community', name: 'ATI Community Health', icon: '🏘️', group: 'proctored', science: true,
    blurb: 'Population health, epidemiology, prevention levels and disaster nursing.',
    minutes: 90, fullLen: 60, pass: 70,
    sections: [
      { id: 'prevention', name: 'Levels of Prevention', weight: 30 },
      { id: 'epi', name: 'Epidemiology & Statistics', weight: 25 },
      { id: 'vulnerable', name: 'Vulnerable Populations', weight: 25 },
      { id: 'disaster', name: 'Disaster & Emergency Preparedness', weight: 20 }
    ]
  },
  {
    id: 'ati-leadership', name: 'ATI Nursing Leadership', icon: '📋', group: 'proctored', science: true,
    blurb: 'Delegation, prioritisation, quality improvement and professional accountability.',
    minutes: 90, fullLen: 60, pass: 70,
    sections: [
      { id: 'delegation', name: 'Delegation & Supervision', weight: 30 },
      { id: 'quality', name: 'Quality Improvement & Safety', weight: 25 },
      { id: 'legal', name: 'Legal & Ethical Practice', weight: 25 },
      { id: 'management', name: 'Resource Management', weight: 20 }
    ]
  },
  {
    id: 'ati-nutrition', name: 'ATI Nursing Nutrition', icon: '🥗', group: 'proctored', science: true,
    blurb: 'Therapeutic diets, nutritional assessment and lifespan nutrition.',
    minutes: 60, fullLen: 50, pass: 70,
    sections: [
      { id: 'diets', name: 'Therapeutic Diets', weight: 35 },
      { id: 'assessment', name: 'Nutritional Assessment', weight: 30 },
      { id: 'lifespan', name: 'Lifespan Nutrition', weight: 35 }
    ]
  },
  {
    id: 'ati-anatomy', name: 'ATI Anatomy & Physiology', icon: '🫀', group: 'proctored', science: true,
    blurb: 'Body systems, homeostasis and structure-function relationships.',
    minutes: 90, fullLen: 60, pass: 70,
    sections: [
      { id: 'cardio-resp', name: 'Cardiovascular & Respiratory', weight: 28 },
      { id: 'neuro', name: 'Nervous & Endocrine', weight: 26 },
      { id: 'musculo', name: 'Musculoskeletal & Integumentary', weight: 24 },
      { id: 'digestive', name: 'Digestive, Renal & Reproductive', weight: 22 }
    ]
  },

  /* =====================================================================
     PRE-MED & SCIENCE
     ===================================================================== */
  {
    id: 'anatomy-physiology', name: 'Anatomy & Physiology I / II', icon: '🦴', group: 'science', science: true,
    blurb: 'Full A&P sequence — cells and tissues through every organ system.',
    minutes: 90, fullLen: 75, pass: 70,
    sections: [
      { id: 'cells', name: 'Cells, Tissues & Homeostasis', weight: 20 },
      { id: 'cardio-resp', name: 'Cardiovascular & Respiratory', weight: 25 },
      { id: 'neuro', name: 'Nervous & Endocrine', weight: 25 },
      { id: 'musculo', name: 'Musculoskeletal & Integumentary', weight: 15 },
      { id: 'digestive', name: 'Digestive, Renal & Reproductive', weight: 15 }
    ]
  },
  {
    id: 'microbiology', name: 'Microbiology', icon: '🦠', group: 'science', science: true,
    blurb: 'Bacteria, viruses, immunology, asepsis and antimicrobial therapy.',
    minutes: 75, fullLen: 60, pass: 70,
    sections: [
      { id: 'bacteria', name: 'Bacteriology', weight: 30 },
      { id: 'virology', name: 'Virology & Mycology', weight: 22 },
      { id: 'immunology', name: 'Immunology', weight: 26 },
      { id: 'control', name: 'Infection Control & Antimicrobials', weight: 22 }
    ]
  },
  {
    id: 'chemistry', name: 'Chemistry for Nursing', icon: '⚗️', group: 'science', science: true,
    blurb: 'General, organic and biological chemistry as taught in pre-nursing.',
    minutes: 75, fullLen: 60, pass: 70,
    sections: [
      { id: 'atomic', name: 'Atomic Structure & Bonding', weight: 25 },
      { id: 'reactions', name: 'Reactions & Stoichiometry', weight: 25 },
      { id: 'solutions', name: 'Solutions, Acids & Bases', weight: 30 },
      { id: 'organic', name: 'Organic & Biochemistry', weight: 20 }
    ]
  },
  {
    id: 'biology', name: 'Biology for Health Sciences', icon: '🧬', group: 'science', science: true,
    blurb: 'Cell biology, genetics, metabolism and evolution.',
    minutes: 75, fullLen: 60, pass: 70,
    sections: [
      { id: 'cells', name: 'Cell Biology', weight: 30 },
      { id: 'genetics', name: 'Genetics & Heredity', weight: 28 },
      { id: 'metabolism', name: 'Metabolism & Energy', weight: 22 },
      { id: 'evolution', name: 'Evolution & Ecology', weight: 20 }
    ]
  },
  {
    id: 'pathophysiology', name: 'Pathophysiology', icon: '🔬', group: 'science', science: true,
    blurb: 'Disease mechanisms across every body system — the bridge into clinical practice.',
    minutes: 90, fullLen: 65, pass: 70,
    sections: [
      { id: 'cellular', name: 'Cellular Injury & Inflammation', weight: 22 },
      { id: 'cardio', name: 'Cardiovascular & Haematologic', weight: 26 },
      { id: 'resp-renal', name: 'Respiratory & Renal', weight: 26 },
      { id: 'neuro-endo', name: 'Neurological & Endocrine', weight: 26 }
    ]
  },
  {
    id: 'mcat', name: 'MCAT (Pre-Med)', icon: '🎓', group: 'science', science: true,
    blurb: 'Medical College Admission Test — the full four-section blueprint.',
    minutes: 450, fullLen: 230, pass: 60,
    sections: [
      { id: 'chem-phys', name: 'Chemical & Physical Foundations', weight: 25 },
      { id: 'cars', name: 'Critical Analysis & Reasoning', weight: 25 },
      { id: 'bio-biochem', name: 'Biological & Biochemical Foundations', weight: 25 },
      { id: 'psych-soc', name: 'Psychological, Social & Biological Foundations', weight: 25 }
    ]
  },

  /* =====================================================================
     PRACTICE QUIZZES — focused drills
     ===================================================================== */
  {
    id: 'dosage-calculation', name: 'Dosage Calculation', icon: '🧮', group: 'quiz', science: true,
    blurb: 'Oral, weight-based, IV and titration calculations. Every answer worked step by step.',
    minutes: 60, fullLen: 50, pass: 90,
    sections: [
      { id: 'oral', name: 'Oral & Injectable Doses', weight: 30 },
      { id: 'weight', name: 'Weight-Based Dosing', weight: 25 },
      { id: 'iv', name: 'IV Flow & Drip Rates', weight: 30 },
      { id: 'conversion', name: 'Unit Conversions', weight: 15 }
    ]
  },
  {
    id: 'pharmacology', name: 'Pharmacology Drill', icon: '💉', group: 'quiz', science: true,
    blurb: 'Drug classes, prototypes, adverse effects and nursing implications.',
    minutes: 60, fullLen: 50, pass: 75,
    sections: [
      { id: 'cardio', name: 'Cardiovascular Agents', weight: 25 },
      { id: 'neuro', name: 'Neuro & Psychiatric Agents', weight: 25 },
      { id: 'anti', name: 'Anti-infectives', weight: 25 },
      { id: 'endocrine', name: 'Endocrine & Pain Agents', weight: 25 }
    ]
  },
  {
    id: 'lab-values', name: 'Lab Values Drill', icon: '🧪', group: 'quiz', science: true,
    blurb: 'Normal ranges and what an abnormal result actually means at the bedside.',
    minutes: 45, fullLen: 40, pass: 80,
    sections: [
      { id: 'electrolytes', name: 'Electrolytes', weight: 35 },
      { id: 'hematology', name: 'Haematology & Coagulation', weight: 25 },
      { id: 'chemistry', name: 'Renal & Hepatic Chemistry', weight: 25 },
      { id: 'abg', name: 'Arterial Blood Gases', weight: 15 }
    ]
  },
  {
    id: 'med-terminology', name: 'Medical Terminology', icon: '📖', group: 'quiz', science: false,
    blurb: 'Prefixes, roots, suffixes and abbreviations used on every unit.',
    minutes: 45, fullLen: 50, pass: 80,
    sections: [
      { id: 'prefix', name: 'Prefixes & Suffixes', weight: 35 },
      { id: 'roots', name: 'Word Roots by System', weight: 35 },
      { id: 'abbrev', name: 'Abbreviations & Symbols', weight: 30 }
    ]
  },
  {
    id: 'ekg', name: 'EKG / Rhythm Interpretation', icon: '📈', group: 'quiz', science: true,
    blurb: 'Rate, rhythm, intervals and the dysrhythmias you must recognise on sight.',
    minutes: 45, fullLen: 40, pass: 80,
    sections: [
      { id: 'basics', name: 'Rate, Rhythm & Intervals', weight: 30 },
      { id: 'atrial', name: 'Atrial Dysrhythmias', weight: 25 },
      { id: 'ventricular', name: 'Ventricular Dysrhythmias', weight: 25 },
      { id: 'blocks', name: 'Blocks & Electrolyte Changes', weight: 20 }
    ]
  },
  {
    id: 'fluid-electrolyte', name: 'Fluids, Electrolytes & Acid-Base', icon: '💧', group: 'quiz', science: true,
    blurb: 'The topic that decides more NCLEX questions than any other single area.',
    minutes: 50, fullLen: 45, pass: 78,
    sections: [
      { id: 'fluids', name: 'Fluid Balance & Tonicity', weight: 30 },
      { id: 'electrolytes', name: 'Electrolyte Imbalances', weight: 40 },
      { id: 'acidbase', name: 'Acid-Base Interpretation', weight: 30 }
    ]
  },

  /* =====================================================================
     CERTIFICATIONS
     ===================================================================== */
  {
    id: 'cna', name: 'CNA Certification', icon: '🏅', group: 'certification', science: true,
    blurb: 'Certified Nursing Assistant written exam plus skills knowledge.',
    minutes: 90, fullLen: 70, pass: 70,
    sections: [
      { id: 'basic-care', name: 'Basic Nursing Skills', weight: 35 },
      { id: 'personal-care', name: 'Personal Care Skills', weight: 25 },
      { id: 'safety', name: 'Safety & Infection Control', weight: 22 },
      { id: 'rights', name: 'Resident Rights & Communication', weight: 18 }
    ]
  },
  {
    id: 'medical-assistant', name: 'Medical Assistant (CMA/RMA)', icon: '🩺', group: 'certification', science: true,
    blurb: 'Clinical and administrative competencies for certification.',
    minutes: 100, fullLen: 80, pass: 70,
    sections: [
      { id: 'clinical', name: 'Clinical Procedures', weight: 40 },
      { id: 'admin', name: 'Administrative & Legal', weight: 30 },
      { id: 'general', name: 'General Medical Knowledge', weight: 30 }
    ]
  },
  {
    id: 'phlebotomy', name: 'Phlebotomy Certification', icon: '🩸', group: 'certification', science: true,
    blurb: 'Order of draw, specimen handling, complications and safety.',
    minutes: 90, fullLen: 70, pass: 70,
    sections: [
      { id: 'collection', name: 'Specimen Collection', weight: 40 },
      { id: 'handling', name: 'Handling & Complications', weight: 30 },
      { id: 'safety', name: 'Safety & Compliance', weight: 30 }
    ]
  },
  {
    id: 'nremt', name: 'NREMT (EMT)', icon: '🚑', group: 'certification', science: true,
    blurb: 'National Registry EMT cognitive exam across all five domains.',
    minutes: 120, fullLen: 110, pass: 70,
    sections: [
      { id: 'airway', name: 'Airway, Respiration & Ventilation', weight: 20 },
      { id: 'cardiology', name: 'Cardiology & Resuscitation', weight: 22 },
      { id: 'trauma', name: 'Trauma', weight: 20 },
      { id: 'medical', name: 'Medical & Obstetrics', weight: 28 },
      { id: 'ops', name: 'EMS Operations', weight: 10 }
    ]
  },
  {
    id: 'acls-bls', name: 'ACLS / BLS / PALS', icon: '❤️', group: 'certification', science: true,
    blurb: 'Resuscitation algorithms, rhythms and medication doses.',
    minutes: 60, fullLen: 50, pass: 84,
    sections: [
      { id: 'bls', name: 'BLS & High-Quality CPR', weight: 30 },
      { id: 'acls', name: 'ACLS Algorithms', weight: 40 },
      { id: 'pals', name: 'PALS & Paediatric Resuscitation', weight: 30 }
    ]
  },
  {
    id: 'ccrn', name: 'CCRN (Critical Care)', icon: '🏥', group: 'certification', science: true,
    blurb: 'Adult critical care nursing certification across all clinical domains.',
    minutes: 180, fullLen: 150, pass: 70,
    sections: [
      { id: 'cardio', name: 'Cardiovascular', weight: 30 },
      { id: 'resp', name: 'Pulmonary', weight: 20 },
      { id: 'multi', name: 'Endocrine, Renal & Haematology', weight: 22 },
      { id: 'neuro', name: 'Neurological & Multisystem', weight: 18 },
      { id: 'professional', name: 'Professional Caring & Ethics', weight: 10 }
    ]
  },
  {
    id: 'cen', name: 'CEN (Emergency Nursing)', icon: '🚨', group: 'certification', science: true,
    blurb: 'Certified Emergency Nurse examination across all presentation categories.',
    minutes: 180, fullLen: 175, pass: 70,
    sections: [
      { id: 'cardio-resp', name: 'Cardiovascular & Respiratory', weight: 30 },
      { id: 'trauma', name: 'Trauma & Musculoskeletal', weight: 25 },
      { id: 'medical', name: 'Medical & Gastrointestinal', weight: 25 },
      { id: 'psych-professional', name: 'Psychosocial & Professional', weight: 20 }
    ]
  },
  {
    id: 'fnp', name: 'FNP Certification (AANP/ANCC)', icon: '👩‍⚕️', group: 'certification', science: true,
    blurb: 'Family Nurse Practitioner board certification — assessment, diagnosis and management.',
    minutes: 180, fullLen: 150, pass: 70,
    sections: [
      { id: 'assess', name: 'Assessment & Diagnosis', weight: 36 },
      { id: 'plan', name: 'Planning & Pharmacotherapeutics', weight: 34 },
      { id: 'evaluate', name: 'Evaluation & Professional Role', weight: 30 }
    ]
  },
  {
    id: 'nurse-educator', name: 'Certified Nurse Educator (CNE)', icon: '🎓', group: 'certification', science: false,
    blurb: 'Teaching strategies, curriculum design, assessment and the educator role.',
    minutes: 180, fullLen: 150, pass: 70,
    sections: [
      { id: 'teaching', name: 'Facilitating Learning', weight: 30 },
      { id: 'assessment', name: 'Assessment & Evaluation', weight: 25 },
      { id: 'curriculum', name: 'Curriculum Design', weight: 25 },
      { id: 'role', name: 'Professional Educator Role', weight: 20 }
    ]
  }
];

window.XP_DIFFICULTIES = [
  { id: 'easy', name: 'Easy', hint: 'Recall and recognition — the foundations you must not lose marks on.' },
  { id: 'moderate', name: 'Moderate', hint: 'Application to a described situation. The bulk of most real exams.' },
  { id: 'hard', name: 'Hard', hint: 'Analysis, prioritisation and multi-step reasoning.' },
  { id: 'advanced', name: 'Advanced Level', hint: 'The hardest tier — complex judgement under time pressure.' },
  { id: 'combined', name: 'Combined (all levels)', hint: 'Mirrors the real spread of difficulty on exam day.' }
];

window.XP_LIMITS = {
  freeMax: 400,
  premiumMax: 2000,
  premiumPrice: 12,
  premiumHandle: 'premium-exam-unlock'
};
